var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VDialog',{style:({ zIndex: 999 }),attrs:{"value":_vm.visible,"content-class":_vm.contentClass,"max-width":_vm.width,"persistent":_vm.persistent},on:{"input":_vm.handleClose}},[_vm._t("default"),_c('NewYearHat')],2)}
var staticRenderFns = []

export { render, staticRenderFns }